import React, {h, Component} from 'preact';
import {PropTypes} from 'preact-compat';
import './DeclineAgentModal.scss';

const SPECIFIC_CITY = 'Prefer an agent that\'s local to the specific city.';

export default class DeclineAgentModal extends Component {
    static get propTypes() {
        return {
            requestId: PropTypes.number,
            responseId: PropTypes.number,
            isBuyer: PropTypes.bool,
            isAdmin: PropTypes.bool,
            agentName: PropTypes.string,
            agentPhotoUrl: PropTypes.string,
            soldCount: PropTypes.number,
            yearsOfExp: PropTypes.number,
            proposalCount: PropTypes.number,
            onDeclineClick: PropTypes.func,
            closePopupAndUpdateProposalsClick: PropTypes.func,
            ltk: PropTypes.string,
            ft: PropTypes.string,
            tracking: PropTypes.string,
            dynamicModules: PropTypes.string,
            agentId: PropTypes.string
        };
    }

    state = {
        reasons: this.props.isBuyer
            ?
            [
                {
                    reason: 'A competing agent\'s profile was more compelling.',
                    value: 'A competing agent\'s profile was more compelling.'
                },
                {
                    reason: 'Very few online reviews.',
                    value: 'Very few online reviews.'
                },
                {
                    reason: 'Prefer other agents with more experience.',
                    value: 'Prefer other agents with more experience.'
                },
                {
                    reason: 'Prefer an agent that\'s local to the specific city.',
                    value: 'Prefer an agent that\'s local to the specific city.'
                }
            ]
            :
            [
                {
                    reason: 'Other agents offer better commission.',
                    value: 'Other agents offer better commission.',
                    note: 'A top agent like ' + this.props.agentName + ' who has ' + this.props.yearsOfExp +
                        ' years of experience and has sold ' + this.props.soldCount +
                        ' homes in your area will sell your home faster and for more money' +
                        ' which far outweighs the commission difference of other options.'
                },
                {
                    reason: 'Prefer other agents with more experience.',
                    value: 'Prefer other agents with more experience.'
                },
                {
                    reason: 'A competing agent\'s profile was more compelling.',
                    value: 'A competing agent\'s profile was more compelling.'
                },
                {
                    reason: 'Other agents offer more services.',
                    value: 'Other agents offer more services.'
                },
                {
                    reason: 'Length of the contract is too long.',
                    value: 'Length of the contract is too long.'
                }
            ],
        specificCity: '',
        specificCityReason: SPECIFIC_CITY,
        declined: false
    };

    handleSelectionChange(reason) {

        for (const r of this.state.reasons) {
            r.isChecked = false;
        }
        reason.isChecked = true;
        this.setState({reasons: this.state.reasons});
    }

    handleDeclineClick() {
        this.props?.onDeclineClick && this.props?.onDeclineClick();

        if(typeof UpNestAnalytics != 'undefined' && UpNestAnalytics != null) {
            const sell_or_buy = this.props?.isBuyer ? 'buy' : 'sell';
            const track = this.props?.tracking == undefined ? 'turn_down' : this.props.tracking;
            UpNestAnalytics.trackEvent("click", {
                pageId: "proposal",
                linkName: 'turn_down',
                modalName: 'turn_down',
                modalTrigger: `${sell_or_buy}:proposal:${track}${this.props?.ltk}${this.props?.ft}`,
                pageType: "proposal",
                siteSection: sell_or_buy,
                rdcTrackingEnabled: "y",
                agentId: this.props?.agentId,
                pageName: `${sell_or_buy}:proposal`,
                ...{dynamicModules: this.props?.dynamicModules}
            });
        }
    }

    handleClosePopupAndUpdateProposalsClick() {
        this.props?.closePopupAndUpdateProposalsClick && this.props?.closePopupAndUpdateProposalsClick();
    }

    handleFormSubmit(event) {
        event.preventDefault();

        const form = event.target;
        const formData = new FormData(form);

        this.setState({isLoading: true});
        $.ajax({
            url: form.action,
            method: form.method,
            processData: false,
            contentType: false,
            data: formData
        }).then(data => {
            if (data.quote) {
                this.setState({declined: true});
            } else {
                checkAjax(data);
            }
        }).always(() => {
            this.setState({isLoading: false});
        });
    }

    renderReason(reason, index) {
        const shouldSubmit = (reason.isChecked && (reason.reason != SPECIFIC_CITY || !this.state.specificCity));
        return (
            <div className="reason">
                <div className="pretty p-icon p-round p-smooth">
                    <input
                        id={'reason-' + index}
                        type="radio"
                        name={shouldSubmit ? 'declineReason' : ''}
                        checked={reason.isChecked}
                        value={reason.value}
                        onChange={e => this.handleSelectionChange(reason)}/>
                    <div className="state p-primary">
                        <img className="icon" src={global.imageBaseUrl + 'proposal/checkbox_blue.svg'}/>
                        <label>{reason.value}</label>
                    </div>
                </div>
                {reason.note && reason.isChecked &&
                    <div className="note">
                        {reason.note}
                    </div>
                }
            </div>
        );
    }

    render() {
        const {requestId, responseId, isBuyer, agentPhotoUrl, proposalCount} = this.props;
        const {isLoading, declined, reasons, specificCity, specificCityReason} = this.state;
        const selectedReason = reasons.filter(r => r.isChecked)[0];
        const remainingProposalCount = proposalCount - 1;

        return (
            <div className="modal nu-modal fade mobile-full-screen decline-agent-modal">
                <div className="modal-dialog">
                    {declined ?
                        <div className="modal-content success">
                            <div className="modal-header">
                                <div className="modal-title mt-3x mt-0-sm text-center">
                                    {agentPhotoUrl &&
                                        <div className="mb-3x mb-4x-sm text-center agent-photo">
                                            <img src={agentPhotoUrl} onError={event => replaceImageOnError(event.target, 'img/profile-icon-l.jpg')}/>
                                        </div>
                                    }
                                    You&apos;ve turned down<br/>this proposal
                                </div>
                            </div>
                            <div className="modal-body text-center">
                                {this.props?.isAdmin ?
                                    <div className="mt-1x-sm mb-1x-sm message">
                                        {remainingProposalCount > 0 ?
                                            <span>
                                                Client have {remainingProposalCount} other proposals to choose from.
                                            </span> : <span>
                                                Client has no remaining proposals.
                                            </span>
                                        }
                                    </div>
                                    :
                                    <div className="mt-1x-sm mb-1x-sm message">
                                        {remainingProposalCount > 0 ?
                                            <span>
                                                It&apos;s okay, you have {remainingProposalCount} other proposals to
                                                choose from.
                                            </span>
                                            :
                                            <span>
                                                You have no remaining proposals. <br/>But don&apos;t worry. You&apos;ll
                                                receive another 3 to 5 personalized proposals from new agents within
                                                24 hours.
                                            </span>
                                        }
                                    </div>
                                }
                            </div>
                            <div className="modal-footer">
                                <div className="text-center">
                                    {this.props?.isAdmin ?
                                        <button
                                            onClick={this.handleClosePopupAndUpdateProposalsClick.bind(this)}
                                            className="btn btn-gray-outline close-button">
                                            Go back to proposals
                                        </button>
                                        :
                                        <a
                                            href={(isBuyer ? 'buyer-received-quotes' : 'seller-received-quotes') + '?requestId=' + requestId}
                                            className="btn btn-gray-outline close-button">
                                            Go back to my proposals
                                        </a>
                                    }
                                </div>
                            </div>
                        </div>
                        :
                        <form
                            className="modal-content"
                            action={isBuyer ? 'decline-buyer-quote-json' : 'declineQuote-json'}
                            method="POST"
                            onSubmit={this.handleFormSubmit.bind(this)}>
                            <input type="hidden" name="quoteId" value={responseId}/>
                            <div className="modal-header hidden-xs">
                                <div className="modal-title">
                                    Please let us know why you are turning down this proposal
                                </div>
                            </div>
                            <div className="modal-body">
                                <div className="mt-3x mb-2x message visible-xs">
                                    Please let us know why you are turning down this proposal:
                                </div>
                                {reasons.map(this.renderReason.bind(this))}
                                {!!selectedReason && selectedReason.reason == SPECIFIC_CITY && !this.props?.isAdmin &&
                                    <div>
                                        <input
                                            type="hidden"
                                            name="declineReason"
                                            className="form-control reason-input"
                                            value={specificCityReason}/>
                                        <input
                                            type="text"
                                            className="form-control reason-input"
                                            placeholder="Fill the city name"
                                            value={specificCity}
                                            onInput={e => {
                                                this.setState({
                                                    specificCity: e.target.value,
                                                    specificCityReason: 'Prefer an agent that\'s local to ' + e.target.value + ' city.'
                                                });
                                            }}/>
                                    </div>
                                }
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-transparent"
                                    data-dismiss="modal">
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="btn btn-red"
                                    disabled={!selectedReason}
                                    onClick={this.handleDeclineClick.bind(this)}>
                                    Turn down proposal
                                </button>
                            </div>
                            {isLoading &&
                                <div className="loadingSpinner" style="display: block; margin: 0">
                                    <img src={global.imageBaseUrl + 'spinner.gif'}/>
                                </div>
                            }
                        </form>
                    }
                </div>
            </div>
        );
    }
}
